<template>
  <div>
    <v-list
        class="with-white-spaces"
        :dense="$vuetify.breakpoint.mobile"
    >
      <v-list-item two-line>
        <v-list-item-avatar>
          <v-icon class="red--text">mdi-alert</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="red--text">{{title}}</v-list-item-title>
          <v-list-item-subtitle v-html="content"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider class="divider"></v-divider>
    <v-row
        v-if="!hideAction"
        class="my-3 text-center"
        no-gutters
    >
      <v-col
          class="px-1"
          cols="6"
          sm="4"
          :offset="hideable ? 0 : 3"
          :offset-sm="hideable ? 2 : 4"
      >
        <v-btn
            class="full-width"
            color="primary"
            small
            @click="$emit('action')">
          Включить
        </v-btn>
      </v-col>
      <v-col
          class="px-1"
          cols="6"
          sm="4"
      >
        <v-btn
            v-if="hideable"
            class="full-width"
            small
            @click="$emit('hide')"
        >
          Скрыть
        </v-btn>
      </v-col>
    </v-row>
    <v-divider v-if="!hideAction"></v-divider>
  </div>
</template>

<script>
export default {
  name: 'Allow',
  props: {
    title: {
      required: true,
      type: String
    },
    content: {
      required: true,
      type: String
    },
    hideable: {
      default: false,
      type: Boolean
    },
    hideAction: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style scoped>

</style>